import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=0fc2e65a&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=ts&"
export * from "./Bookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2e65a",
  null
  
)

export default component.exports